import { InteractiveContainer } from "@jugl-web/ui-kit";
import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { EntityInvitationModel } from "@jugl-web/rest-api";
import { EntityInvitationCard } from "@web-src/modules/entities/components/EntityInvitationCard";

interface CXInvitationsListProps {
  invitations: EntityInvitationModel[];
  onAccepted: (entityId: string) => void;
  onCreateWorkspace: () => void;
}

export const CXInvitationsList: React.FC<CXInvitationsListProps> = ({
  invitations,
  onAccepted,
  onCreateWorkspace,
}) => {
  const { t } = useTranslations();

  return (
    <div className="my-auto flex w-full max-w-[566px] flex-col items-center justify-center gap-4 py-2 sm:gap-6 sm:py-4">
      <span className="text-center font-secondary text-[28px] leading-9 font-medium text-dark sm:text-[32px] sm:leading-[48px]">
        {t({
          id: "cx-invitations-page.youve-been-invited",
          defaultMessage: "You've been invited!",
        })}
      </span>
      <span className="text-center font-secondary text-sm leading-4 text-grey-900">
        {t({
          id: "cx-invitations-page.select-workspace-to-join",
          defaultMessage: "Select a workspace below to join and get started.",
        })}
      </span>
      <div className="jugl__custom-scrollbar flex max-h-[300px] w-full flex-col gap-3 overflow-y-auto">
        {invitations.map((invitation) => (
          <EntityInvitationCard
            key={invitation.id}
            invitation={invitation}
            disableDelete
            onInvitationAcceptedSuccess={() => onAccepted(invitation.entityId)}
          />
        ))}
      </div>
      <InteractiveContainer
        className="mt-2 font-secondary text-sm text-primary-600 underline"
        onClick={onCreateWorkspace}
      >
        {t({
          id: "cx-invitations-page.create-new-workspace",
          defaultMessage: "Or create a new workspace",
        })}
      </InteractiveContainer>
    </div>
  );
};
